/*eslint-disable eqeqeq*/
import React from 'react';
import PracticesList from '../../component/componentPractices/practiceslist';
// import { data } from './practicesdata'
import * as APIController from '../../../../api/APIController.js';
import Notification from '../../../../shared/components/notification/notification';
import * as AppConstants from "../../../../config/AppConstant"

class PracticesContainer extends React.Component {

    state = {
        currentPage: 1,
        count: 0,
        rowsPerPage: 10,
        rowsPerPageOptions: [10, 25, 50, 'All'],
        list: [],
        from: 0,
        to: 10,
        progress: true,
        message: '',
        showNotification: false,
        isError: false,
        showMessage: this.props.history.location.state != null && this.props.history.location.state.showMessage
    }

    componentDidMount() {
        this.wsGetPractices(this.state.currentPage, this.state.rowsPerPage, this.state.from, this.state.to);
        this.state.showMessage != '' && this.handleNotification(this.state.showMessage)
        this.props.history.replace('/practices', null);
    }

    wsGetPractices(CurrentPage, RecordPerPage, from, to, RegistrationDate, PracticeName, ShipToNo, Representative, ContactName, Address1, Address2, City, State, Postcode, EmailAddress, PhoneNo, VisionSource, VSP, IsCoOp, Status) {
        this.setState({ progress: true, });
        APIController.GetPractices(CurrentPage, RecordPerPage, RegistrationDate, PracticeName, ShipToNo, Representative, ContactName, Address1, Address2, City, State, Postcode, EmailAddress, PhoneNo, VisionSource, VSP, IsCoOp, Status)
            .then((response) => {
                if (response.error == null && response.object.data.length != 0) {
                    this.setState({
                        to: isNaN(to) ? 1000000 : to,
                        from: from,
                        count: response.object.data[0].MaxRows,
                        list: response.object.data,
                        progress: false,
                    })
                }
                else if (response.object.message && response.object.message.length > 0) {
                    // ToastsStore.warning(response.error.message)
                } else { this.setState({ list: [], progress: false }) }
            })
    }

    render() {
        return (
            <>
                <Notification
                    isError={this.state.isError}
                    message={this.state.message}
                    showNotification={this.state.showNotification}
                    clearNotification={this.handleClearNotification}
                    closeNotification={this.handleClearNotification}
                />
                <section className="content-right-main">
                    {AppConstants.GetMainClassName() == "app-yomi" &&
                        <div className="button-field button-field-country">
                            <button onClick={() => { this.props.history.push("/admin/importPracticesUsers"); }}> + Import Practice & User </button>
                        </div>}
                    <PracticesList
                        {...this.state}
                        history={this.props.history}
                        handleChangeRowsPerPage={this.handleRowsPerPageChange}
                        handleChangePage={this.handlePageChange}
                        applyFilter={this.handleApplyFilter}
                    />
                </section>
            </>
        )
    }

    /**
     * handleRowsPerPageChange method is used to update rows per page
     * it will reset page to 1
     */
    handleRowsPerPageChange = (value, RegistrationDate, PracticeName, ShipToNo, Representative, ContactName, Address1, Address2, City, State, Postcode, EmailAddress, PhoneNo, VisionSource, VSP, IsCoOp, Status) => {
        let from = 0
        let to = value;
        this.setState({ rowsPerPage: value, currentPage: 1, to: to, from: from })
        this.wsGetPractices(isNaN(value) ? '' : this.state.currentPage, isNaN(value) ? 1000000 : value, from, to, RegistrationDate, PracticeName, ShipToNo, Representative, ContactName, Address1, Address2, City, State, Postcode, EmailAddress, PhoneNo, VisionSource, VSP, IsCoOp, Status);
    }

    /**
     * handlePageChange method is used to change page
     */
    handlePageChange = (values, RegistrationDate, PracticeName, ShipToNo, Representative, ContactName, Address1, Address2, City, State, Postcode, EmailAddress, PhoneNo, VisionSource, VSP, IsCoOp, Status) => {
        let from = values === 1 ? 0 * this.state.rowsPerPage : (values - 1) * this.state.rowsPerPage
        let to = values === 1 ? this.state.rowsPerPage : (from + this.state.rowsPerPage);
        this.setState({ currentPage: Number(values) })
        this.wsGetPractices(Number(values), this.state.rowsPerPage, from, to, RegistrationDate, PracticeName, ShipToNo, Representative, ContactName, Address1, Address2, City, State, Postcode, EmailAddress, PhoneNo, VisionSource, VSP, IsCoOp, Status);
    }

    /**
     * handleApplyFilter method is used to apply filter on every columns
     */
    handleApplyFilter = (RegistrationDate, PracticeName, ShipToNo, Representative, ContactName, Address1, Address2, City, State, Postcode, EmailAddress, PhoneNo, VisionSource, VSP, IsCoOp, Status) => {
        this.wsGetPractices(this.state.currentPage, this.state.rowsPerPage, this.state.from, this.state.to, RegistrationDate, PracticeName, ShipToNo, Representative, ContactName, Address1, Address2, City, State, Postcode, EmailAddress, PhoneNo, VisionSource, VSP, IsCoOp, Status);
    }
    handleNotification = (message, isError) => {

        this.setState({
            message: message,
            showNotification: true,
            isError: isError
        })

        setTimeout(() => {
            this.handleClearNotification();
        }, 4000)
    }

    handleClearNotification = () => {
        this.setState({
            message: '',
            showNotification: false,
            isError: false
        })
    }
}

export default PracticesContainer;